
import { SlideShowScreen } from '../../ui/SlideShowScreen';
import { CarrouselScreen } from '../../ui/CarrouselScreen';
import { useProdcutosCArruseles, useSlideShowHomePrincipal } from '../../../hooks/cache';
import { Box } from '@mui/material';
import { CargandoMedio } from '../../components';




export const HomeScreen = () => {

    const { data, isLoading } = useProdcutosCArruseles();
    const { data:slide, isLoading:loadingSlide } = useSlideShowHomePrincipal();


    return (

        <Box sx={{ width:'100%' }}>
            {(loadingSlide) 
            ?   <CargandoMedio titulo="Cargando información de promoxiones..." />
            :   <SlideShowScreen data={slide || []} />
            }
            
            {(isLoading) 
            ?   <CargandoMedio titulo="Cargando información de productos..." />
            :   <>
                <CarrouselScreen titulo={'Publicidad'}  producto={data.publicidad || []}/>
                <CarrouselScreen titulo={'Servicio Técnico'} producto={data.servicio || []} />
                <CarrouselScreen titulo={'Personalizados'} producto={data.personalizados || []} />
                </>
            }
        </Box>
    )
}
